export enum ViabilityStatusColor {
  Poor = '#CC3333',
  Fair = '#DDBA00',
  Good = '#A6D4A5',
  VeryGood = '#037429',
}